import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBBtn,
} from "mdbreact";

import "../css/scrollbar.css";

import AccessDenied from "../components/AccessDenied";

import AddEditVehicle from "./AddEditVehicle";
import AddEditVehicleCustomer from "./AddEditVehicleCustomer";
import Spinner from "../components/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronUp,
  faPenToSquare,
  faSquarePlus,
} from "@fortawesome/free-solid-svg-icons";

const VehicleCustomerView = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [rows, setRows] = useState([]);
  const [showPreloader, setPreloader] = useState("normal");

  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = () => {
    showAddEdit(!modalAddEdit);
    loadData();
  };

  const [bRefresh, setRefresh] = useState(false);
  function refreshGrid() {
    setRefresh(!bRefresh);
    loadData();
  }

  function loadData() {
    Axios.get(
      props.apiServer +
        "/myvehicles?usercode=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const useMountEffect = (functionName) => useEffect(functionName, []);
  useMountEffect(loadData);
  return (
    <React.Fragment>
      <MDBRow>
        <MDBCol md="12">
          {showPreloader === "normal" ? (
            <Spinner />
          ) : (
            <React.Fragment>
              <MDBRow>
                <MDBCol md="8">
                  <span className="h5-responsive font-weight-bold">
                    VEHICLES
                  </span>
                  &nbsp;|&nbsp;
                  <span className="h6-responsive font-weight-bold brown-text">
                    {sessionStorage.getItem("Email")}
                  </span>
                </MDBCol>
                <MDBCol md="4">
                  <MDBBtn
                    onClick={toggleAddEdit}
                    className="cloudy-knoxville-gradient brown-text float-right"
                  >
                    <FontAwesomeIcon icon={faSquarePlus} />
                    {"  "}
                    Add New Vehicle
                  </MDBBtn>
                </MDBCol>
              </MDBRow>

              <MaterialTable
                title=""
                columns={[
                  { title: "Make", field: "carmake" },
                  { title: "Variant", field: "variant" },

                  { title: "Plate No", field: "plateno" },
                  { title: "Deleted", field: "deleted" },
                ]}
                data={rows}
                options={{
                  search: true,
                  actionsColumnIndex: -1,
                }}
                detailPanel={[
                  {
                    icon: () => <FontAwesomeIcon icon={faPenToSquare} />,
                    openIcon: () => (
                      <FontAwesomeIcon
                        className="red-text font-weight-bold"
                        icon={faChevronUp}
                      />
                    ),
                    tooltip: "Vehicle Details",
                    render: (rowData) => {
                      return (
                        <React.Fragment>
                          <MDBCard>
                            <MDBCardHeader>Vehicle Details</MDBCardHeader>
                            <MDBCardBody>
                              <AddEditVehicleCustomer
                                deployURL={props.deployURL}
                                apiServer={props.apiServer}
                                code={rowData.code}
                                apiServerHybrid={props.apiServerHybrid}
                                toggleModal={toggleAddEdit}
                                refreshGrid={refreshGrid}
                                quicktool="no"
                              />
                            </MDBCardBody>
                          </MDBCard>
                        </React.Fragment>
                      );
                    },
                  },
                ]}
              />
            </React.Fragment>
          )}
        </MDBCol>
      </MDBRow>

      <MDBModal
        backdrop={false}
        isOpen={modalAddEdit}
        toggleModal={toggleAddEdit}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBCard>
          <MDBCardHeader className="primary-color">
            <h5 className="h5-responsive white-text">
              <b>Add New Vehicle</b>
            </h5>
          </MDBCardHeader>
          <MDBCardBody>
            <AddEditVehicleCustomer
              deployURL={props.deployURL}
              apiServer={props.apiServer}
              apiServerHybrid={props.apiServerHybrid}
              code={""}
              toggleModal={toggleAddEdit}
              refreshGrid={refreshGrid}
              // toggleModal2={props.toggleModal2}
              // quicktool="yes"
            />
          </MDBCardBody>
        </MDBCard>

        {/* <AddEditDirectiveDetails toggleModal={toggleAddEdit} code={"newrecord"} directivecode={props.code}  apiServer={props.apiServer} loadDirectivesMain={props.loadDirectivesMain}/> */}
      </MDBModal>

      {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
    </React.Fragment>
  );
};

export default VehicleCustomerView;
